import { render, staticRenderFns } from "./reseller_order_alarm.vue?vue&type=template&id=49b7a9f0"
import script from "./reseller_order_alarm.vue?vue&type=script&lang=js"
export * from "./reseller_order_alarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports